module.exports = __webpack_public_path__ + "media/images/img-pb-lite-e3ead1d2549ac2a774e5ef1fb3049fd9.png";